<app-timer-work-list
  [works]="works | async"
  [timerRows]="timerRows | async"
  [selectedDate]="selectedDate | async"
  [suggestions]="suggestions | async"
  (createTimer)="createTimer($event)"
  (showTimer)="showTimer($event)"
  (createWorkEntry)="createWorkEntry($event)"
  (selectSuggestion)="selectSuggestion($event)"
  (start)="start($event)"
  (stop)="stop()"
  (editWork)="editWork($event)"
>
</app-timer-work-list>
